import axios from 'axios'

/**
 * @desc Fetches tenant settings - note the response may differ slightly depending on if the request is
 * for an authenticated user or not
 */
export const fetchTenantSettings = () =>
  axios
    .get('/settings')
    .then((res) => res.data)
    .catch((err) => Promise.reject(err))
